import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { updateSmsUsageBlock } from 'api/admin/smsUsage/smsUsage';
import { SMS_USAGE_QUERY_KEY } from 'api/queries/useSmsUsage';
import { ApiError } from 'types/api';
import { UpdateSmsUsageBlockPayload } from 'types/smsUsage/smsUsage';

const describeBlock = ({ prefix, blocked }: UpdateSmsUsageBlockPayload): string =>
  `${prefix === undefined ? 'Business' : 'Prefix'} block ${blocked ? 'turned on' : 'turned off'}`;

export const useUpdateSmsUsageBlock = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, ApiError, UpdateSmsUsageBlockPayload>({
    mutationFn: async (payload) => {
      await updateSmsUsageBlock(payload);
    },
    // Returning the refetch keeps the mutation pending until the table shows the new state,
    // so a toggle can't be flipped again against stale rows.
    onSuccess: async (_, payload) => {
      toast.success(describeBlock(payload), { duration: 4000 });
      await queryClient.invalidateQueries({ queryKey: [SMS_USAGE_QUERY_KEY] });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(
        error?.response?.data?.error ?? 'An error occurred while updating the SMS usage block',
        { duration: 4000 },
      );
    },
  });
};
